import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationEN from './locales/en/translantion.json';
import translationLA from './locales/la/translantion.json';

// the translations
const resources = {
    en: {
        translation: translationEN
    },
    la: {
        translation: translationLA
    }
};

i18n
    .use(detector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        // keySeparator: false,
        keySeparator: '.',
        returnObjects: true,
        fallbackLng: "la", // use en if detected lng is not available
        // lng: "la",
    });

export default i18n;